import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { TypeComplaint } from "../models";

@Injectable()
export class TypeComplaintService {

    typeComplaintsUrl = environment.dns + 'api/type/complaints/';

    constructor(private http: HttpClient) { }

    getList(): Observable<TypeComplaint[]> {
        return this.http.get<TypeComplaint[]>(this.typeComplaintsUrl + 'list');
    }


}